export default {
    feature_tab_edit_features: "Editar características",
    feature_tab_show_in_web: "Mostrar en la web",
    feature_tab_promiles: "Promiles",
    feature_tab_send_calc_odometer: "Enviar Calc Odómetro",
    feature_tab_analytics: "Analítica",
    feature_tab_apu: "APU",
    feature_tab_hybrid: "Híbrido",
    feature_tab_vbus: "Vbus",
    feature_tab_jbus: "Jbus",
    feature_tab_show_ecu_speed: "Mostrar velocidad de la ECU",
    feature_tab_use_ecu_odometer: "Utilizar el cuentakilómetros de la ECU",
    feature_tab_driver_behavior: "Comportamiento del conductor",
    feature_tab_edit_device: "Editar dispositivo",
    feature_tab_the_device_has_been_edited: "El dispositivo ha sido editado",
    feature_tab_device_category: "Categoría del dispositivo",
    feature_tab_features: "Características",
    feature_tab_use_ecu_vin: "Utilizar ECU Vin",
    feature_tab_device_name: "Nombre del dispositivo",
    feature_tab_asset: "Activo",
    feature_tab_fleet: "Flota",
    feature_tab_timezone: "Zona Horaria",
    feature_tab_cariq: "Car IQ",
    feature_tab_install_status: "Estado de Instalación",
    feature_tab_installed: "Instalado",
    feature_tab_pending_install: "Instalación Pendiente",
    feature_tab_installed_on: "Fecha Instalación",
    feature_tab_installed_on_valid: "Seleccionar una fecha de instalación valida",
    feature_tab_select_date: "Seleccionar una fecha",
    feature_tab_tz_to_gps: "El cambio en la zona horaria tambien aplicara al dispositivo emparejado",
    feature_tab_tz_to_camera: "El cambio en la zona horaria tambien aplicara a la cámara emparejada",
    feature_tab_tz_not_supported: "La zona horaria seleccionada no es soportada por la configuración de vidfleet",
    feature_tab_carb: "Carb",
    feature_tab_billing_account: "Cuenta de Facturación",
    feature_tab_use_ecu_engine_hours: "Utilizar horas de motor de la ECU",
}